import JsBarcode from 'jsbarcode';

export function buildPrescriptionBarcodeValue(prescriptionTag, prescriptionNumber) {
  const tag = String(prescriptionTag || '').replace(/[^a-z0-9]/gi, '');
  if (tag) return tag.toUpperCase();

  const digits = String(prescriptionNumber || '').replace(/\D/g, '');
  return digits ? `O${digits}` : null;
}

export function renderPrescriptionBarcodeCanvas(
  value,
  { width = 3, height = 80, displayValue = true, fontSize = 18, margin = 10 } = {}
) {
  if (!value) return null;
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, value, {
    format: 'CODE128',
    width,
    height,
    displayValue,
    font: 'Arial',
    fontSize,
    textMargin: 4,
    margin,
    background: '#ffffff',
    lineColor: '#000000'
  });
  return canvas;
}

export function renderPrescriptionBarcodeDataUrl(value, options) {
  try {
    return renderPrescriptionBarcodeCanvas(value, options)?.toDataURL('image/png') || null;
  } catch {
    return null;
  }
}